const ChangeCalculator = require('@/libraries/DigiTickets/Payment/ChangeCalculator');
const EventNames = require('@/lib/Events/EventNames');
const Payment = require('@/lib/Payments/Payment');
const PaymentMethodRef = require('@/lib/PaymentMethods/PaymentMethodRef');

/**
 * This is the controller for the inner part of the payment modal for the payment method of "Cash".
 *
 * @param $scope
 * @param {CartService} cartService
 * @param {NumPadFactory} numPadFactory
 * @param {PaymentMethodService} paymentMethodService
 * @param {ToastFactory} toastFactory
 */
const CashCtrl = function CashCtrl(
    $scope,
    cartService,
    numPadFactory,
    paymentMethodService,
    toastFactory
) {
    $scope.paymentMethodScopes[PaymentMethodRef.CASH] = $scope;

    $scope.thisPaymentMethodRef = PaymentMethodRef.CASH;
    $scope.thisPaymentMethod = paymentMethodService.getByRef($scope.thisPaymentMethodRef);

    $scope.cart = cartService;

    $scope.calculator = new ChangeCalculator();
    $scope.numPad = numPadFactory.create(
        {
            showCashButtons: true,
            showSignButton: false,
            doNotCaptureKeysIn: ['input'],
        }
    );

    $scope.clear = function clear() {
        $scope.calculator.clear();
        $scope.numPad.clear();
    };

    $scope.numPad.onChange(function (value) {
        const maxTendered = 99999999.99;

        // Block the number going higher than what the database can handle (10,2).
        if (value > maxTendered) {
            $scope.numPad.removeLastNumber();
            return;
        }

        // When the number pad value changes update the calculator.
        $scope.calculator.setAmountTendered(value);
        $scope.setNumPadTotal(value);
    });
    $scope.numPadListening = false;

    $scope.setAmountDue = function setAmountDue(amount) {
        $scope.calculator.setAmountDue(amount);
        $scope.numPad.setExactAmount(amount);
        $scope.numPad.options.isNegative = amount < 0;
    };

    $scope.setAmountDue($scope.cart.getRemainingBalance());

    $scope.$on('payment-modal.payment-removed', function () {
        $scope.setAmountDue($scope.cart.getRemainingBalance());
    });

    $scope.$on('payment-modal.cancel-pressed', function (event, paymentMethodRef) {
        if (paymentMethodRef === $scope.thisPaymentMethodRef) {
            // Was cancelled from the cash tab.
            $scope.clear();
            $scope.setAmountDue($scope.cart.getRemainingBalance());
        }
    });

    $scope.$on(EventNames.PAYMENT_METHOD_CHANGED, function (event, newPaymentMethod) {
        const newPaymentMethodRef = newPaymentMethod?.ref;
        // Changing tab, so reset the calculator.
        $scope.clear();
        $scope.setAmountDue($scope.cart.getRemainingBalance());

        $scope.numPadListening = newPaymentMethodRef === $scope.thisPaymentMethodRef;
    });

    /**
     * This is called by the parent PaymentCtrl when the "received payment" button is clicked.
     * It is an opportunity to do something different than allowing the PaymentCtrl to generate a payment
     * for the remaining balance and add it to the cart.
     *
     * If this returns true it means we are intercepting the event, doing something special, and PaymentCtrl
     * should not generate and add its own payment.
     *
     * @return {boolean}
     */
    $scope.onPaymentReceivedPress = () => {
        if ($scope.cart.getSelectedPaymentMethodRef() !== $scope.thisPaymentMethodRef) {
            // We're not the active payment method. Do nothing.
            return false;
        }

        let amountTendered = $scope.calculator.getAmountTendered();

        // If the cart doesn't allow partial payments (currently so if it contains memberships), then
        // we need to check that the cash paid is at least as big as the order total.
        $scope.$parent.clearError();
        if ($scope.cart.getRemainingBalance() > 0 && !$scope.cart.allowPartialPayments()) {
            // Partial payments are not allowed.
            if (amountTendered < $scope.cart.getRemainingBalance()) {
                // They haven't paid enough, so we can't accept it.
                $scope.$parent.setError('Partial payments are not allowed for this order');
                return true;
            }
        }

        if ($scope.cart.isRefund() && amountTendered < $scope.cart.getRemainingMaxPayment()) {
            toastFactory.warningTop(
                null,
                {
                    key: 'PAYMENT.MAX_AMOUNT_ALERT--REFUND--RECEIVED',
                    params: { max: $scope.cart.getRemainingMaxPayment() },
                }
            );

            $scope.preventClose();
            return true;
        }

        if ((!$scope.cart.isRefund() && amountTendered > 0) || ($scope.cart.isRefund() && amountTendered < 0)) {
            let payment = new Payment();
            payment.setPaymentMethod($scope.thisPaymentMethod);
            payment.setTendered(amountTendered);
            payment.setThirdPartyID($scope.cart.generatePaymentThirdPartyID());
            $scope.addPayment(payment);
        }

        // Clear for next use.
        $scope.clear();
        $scope.setAmountDue($scope.cart.getRemainingBalance());

        return true;
    };
};

module.exports = CashCtrl;
